import Cookies from "js-cookie";
import { on, ready } from "../utils/listeners";

const mainShadow = document.querySelector(".mobile-nav-shadow");

const backgroundHome = document.querySelector(".js-menu-wrapper-home");

const html = document.documentElement;
const { body } = document;

const gnav = document.querySelector(".gnav");

on("click", ".js-menu-toggle-text", element => {
  const submenuContent = element
    .closest(".js-menu-toggle")
    .querySelector(".submenu-content");
  // The lower menu level's overflow needs to be hidden whenever the menu opens, otherwise it gets in the way of the swiping.
  submenuContent.scrollTop = 0;
  backgroundHome.classList.add("disable-scroll");
});

// Locks <html> alone: locking <body> as well makes it a scroll container, which unsticks the
// sticky header that stays in view above the panels.
const lockPage = () => {
  html.classList.add("overflow-y-hidden");
};

// Shared by the category and account menus: the header takes the menu's background and the open
// menu's own icon becomes its close control.
const setHeaderForOpenMenu = (toggle, { account = false } = {}) => {
  lockPage();
  body.classList.add("mobile-menu-open");
  toggle.classList.toggle("menu-open", !account);
  gnav?.classList.toggle("account-menu-open", account);
  gnav?.classList.add("nav-menu-open");
  // The panels open below the header, so the promo banner hides to keep the header at the top of
  // the screen.
  body.classList.add("promo-banner-hidden");

  if (gnav) gnav.style.transform = "none";
};

on("click", ".js-menu-toggle", (element, event) => {
  // Tapping an account link lands here on the root toggle and would open the
  // category menu — flashing it on screen before the browser navigates away.
  if (
    element.classList.contains("menu-toggle") &&
    event.target.closest(".menu")
  )
    return;

  element.querySelector(".menu").classList.add("in");
  lockPage();

  // Only the root toggle opens the full menu; the drilldown levels share this hook but must
  // not restyle the header behind the panel or close the account menu.
  if (element.classList.contains("menu-toggle")) {
    element.querySelector(".js-account-menu")?.classList.remove("in");
    setHeaderForOpenMenu(element);
  }

  if (gnav) gnav.style.transform = "none";
});

const closeMenus = toggle => {
  toggle.querySelectorAll(".menu").forEach(el => el.classList.remove("in"));
  toggle.classList.remove("menu-open");
  gnav?.classList.remove("account-menu-open");
  gnav?.classList.remove("nav-menu-open");
  body.classList.remove("mobile-menu-open");
  body.classList.remove("promo-banner-hidden");
  html.classList.remove("overflow-y-hidden");
  backgroundHome.classList.remove("disable-scroll");
};

on("click", ".js-menu-close", element => {
  closeMenus(element.closest(".menu-toggle"));
});

on("click", ".js-account-menu-toggle", () => {
  const toggle = document.querySelector(".menu-toggle");
  const accountMenu = toggle?.querySelector(".js-account-menu");

  if (!accountMenu) return;

  // Showing the close icon, so a second tap shuts the menu.
  if (accountMenu.classList.contains("in")) {
    closeMenus(toggle);
    return;
  }

  // The category panels and the account panel are siblings, so close those before opening this —
  // moving between the two menus swaps them rather than stacking them.
  toggle.querySelectorAll(".menu").forEach(el => el.classList.remove("in"));
  accountMenu.classList.add("in");
  setHeaderForOpenMenu(toggle, { account: true });
});

on("click", ".js-menu-back", element => {
  element.closest(".menu").classList.remove("in");
  backgroundHome.classList.remove("disable-scroll");
});

if (backgroundHome) {
  backgroundHome.addEventListener("scroll", () => {
    const yScrollPosition = backgroundHome.scrollTop;

    window.requestAnimationFrame(() => {
      if (yScrollPosition < 1) {
        mainShadow.classList.remove("show");
      } else {
        mainShadow.classList.add("show");
      }
    });
  });
}

const submenus = document.querySelectorAll(".submenu-content");

submenus.forEach(b => {
  const shadow = b.previousElementSibling;
  b.addEventListener("scroll", () => {
    const yScrollPosition = b.scrollTop;

    window.requestAnimationFrame(() => {
      if (yScrollPosition < 1) {
        shadow.classList.remove("show");
      } else {
        shadow.classList.add("show");
      }
    });
  });
});

const creditNotifierCookie = Cookies.get("userViewedCreditPage");
const userViewedCreditCookie = creditNotifierCookie === "true";

ready(() => {
  if (!userViewedCreditCookie) {
    const elements = document.getElementsByClassName(
      "js-credit-notifier-mobile"
    );

    if (elements.length > 0) {
      Array.from(elements).forEach(el => {
        el.classList.remove("hidden");
      });
    }
  }
});

on("click", "#credit", element => {
  let { userHasCredit } = element.dataset;

  userHasCredit = userHasCredit === "true";

  const notificationShown = !userViewedCreditCookie && userHasCredit;

  analytics.track("User Clicked Credit Dropdown", {
    notificationShown
  });
});
